import {MessageBoxAction} from './message-box-actions';

export enum MessageSeverity {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SUCCESS = 'success',
    DANGER = 'danger',
    WARNING = 'warning',
    INFO = 'info',
    DARK = 'dark',
    LIGHT = 'light',
}

export type MessageBoxState = {
    [id: string]: {
        heading?: string;
        text: string;
        severity?: MessageSeverity;
        timeout: number;
    };
};

const initialState: MessageBoxState = {};

const messageBoxReducer = (
    state: MessageBoxState = initialState,
    action: MessageBoxAction
): MessageBoxAction | MessageBoxState | undefined | any => {
    switch (action.type) {
        case 'SHOW_MESSAGE': {
            const message = {};
            message[action.id] = {
                heading: action.heading,
                text: action.text,
                severity: action.severity,
                timeout: action.timeout || -1,
            };
            return {
                ...state,
                ...message,
            };
        }
        case 'CLEAR_MESSAGE': {
            const clonedMessages = {
                ...state,
            };
            delete clonedMessages[action.id];
            return clonedMessages;
        }
        default:
            return state;
    }
};

export default messageBoxReducer;
